import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { HomePage } from '@/routes/store/HomePage';
import { ShopPage } from '@/routes/store/ShopPage';
import { NotFoundPage } from '@/routes/NotFoundPage';
import { RouteError } from './RouteError';

const AdminApp = lazy(() =>
  import('@/routes/admin/AdminApp').then((module) => ({ default: module.AdminApp })),
);

function RouteFallback() {
  return (
    <div className="grid min-h-screen place-items-center text-sm text-brand-muted">Loading…</div>
  );
}

export const router = createBrowserRouter([
  {
    // One boundary for the whole tree: an uncaught render error anywhere lands
    // on RouteError instead of React Router's developer page.
    errorElement: <RouteError />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/shop', element: <ShopPage /> },
      {
        path: '/admin/*',
        element: (
          <Suspense fallback={<RouteFallback />}>
            <AdminApp />
          </Suspense>
        ),
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
